import { render, staticRenderFns } from "./ModalSettings.vue?vue&type=template&id=2fce71cc&"
import script from "./ModalSettings.vue?vue&type=script&lang=js&"
export * from "./ModalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports